export const Search = 'Search';
export const CreateDisplayTxt = 'Create';
export const Create = 'Create';
export const Notifications = 'Notifications';
export const UserName = 'UserName';
export const Results = 'Results';
export const LILApps = 'LILApps';
export const uploadCsv = 'Upload CSV';
export const manualEntry = 'Manual Entry';
export const assetsReporting = 'Assets Reporting Dashboard';

export const Search_Root_NavLink_To = '/';
export const Search_Alt_NavLink_To = '/Search';
export const Create_NavLink_To = '/Create';
export const Create_UploadCsv_NavLink_To = '/UploadCsv';
export const Create_ManualEntry_NavLink_To = '/ManualEntry';
export const Notifications_NavLink_To = '/Notifications';
export const Results_NavLink_To = '/Search/Results';
export const ManageAssets_NavLink_To = '/Search/Results/ManageAsset';
export const ManageProducts_NavLink_To = '/Search/Results/ManageProduct';
